import TagManager from 'react-gtm-module';
import {COOKIE_CONSENT_KEY, COOKIE_PREFERENCES_KEY} from './CookieConsent';

export const getStoredPreferences = () => {
    try {
        const raw = localStorage.getItem(COOKIE_PREFERENCES_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const hasUserConsented = () => {
    return !!localStorage.getItem(COOKIE_CONSENT_KEY);
};

// Tracks whether GTM has been initialized so we never call it twice.
let gtmInitialized = false;

/**
 * Initialize GTM only when the user has consented to analytics or marketing.
 * Calling this multiple times is safe — it only runs once.
 */
export const initializeGTM = (preferences) => {
    if (gtmInitialized) return;
    if (!preferences?.analytics && !preferences?.marketing) return;

    const gtmId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
    if (!gtmId) return;

    TagManager.initialize({gtmId});
    gtmInitialized = true;
};

/**
 * Push Google Consent Mode v2 signals to dataLayer.
 * Used to update consent state after GTM is already loaded.
 */
export const applyGoogleConsent = (preferences, mode = 'update') => {
    window.dataLayer = window.dataLayer || [];

    const analytics  = preferences?.analytics  ? 'granted' : 'denied';
    const marketing  = preferences?.marketing  ? 'granted' : 'denied';
    const functional = preferences?.functional ? 'granted' : 'denied';

    window.dataLayer.push(['consent', mode, {
        analytics_storage:       analytics,
        ad_storage:              marketing,
        ad_personalization:      marketing,
        ad_user_data:            marketing,
        functionality_storage:   functional,
        personalization_storage: functional,
        wait_for_update:         500,
    }]);
};
